import React from "react"
import { Box } from "@mui/material"
import {
	Edit,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import sx from "utils/sx"

const JobEdit = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.jobs.notifications.edit",
			{
				type: "info",
				messageArgs: { name: data.name }
			}
		)
		redirect("/jobs")
		refresh()
	}

	return (
		<Edit
			mutationOptions={{ onSuccess }}
			title="resources.jobs.edit"
			mutationMode="pessimistic"
		>
			<SimpleForm>
				<Box sx={sx.prose}>
					<TextInput
						source="name"
						label="resources.jobs.fields.name"
						validate={required()}
						fullWidth
					/>
				</Box>
			</SimpleForm>
		</Edit>
	)
}


export default JobEdit
